<app-loader></app-loader>
<router-outlet></router-outlet>
<app-intro-splash></app-intro-splash>
